import {TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button} from '@primer/react'
import {useCallback, useMemo} from 'react'
import {
  DockedPanel,
  useEnabledDockedPanels,
  useActiveDockedPanel,
  useDockedPanelActions,
} from '../../contexts/DockedPanelContext'
import styles from './Panel.module.css'
import {getPanelHeading} from './panel-registry'

export function PanelNavigationDropdown() {
  const {openPanel} = useDockedPanelActions()
  const activePanel = useActiveDockedPanel()
  const enabledPanels = useEnabledDockedPanels()

  const currentValue = useMemo(() => {
    return activePanel || DockedPanel.Comments
  }, [activePanel])

  const handleSelect = useCallback(
    (value: DockedPanel) => {
      openPanel(value)
    },
    [openPanel],
  )

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Button
          aria-label={getPanelHeading(currentValue)}
          trailingVisual={TriangleDownIcon}
          size="small"
          variant="invisible"
          className={styles.PanelNavigationDropdown}
        >
          {getPanelHeading(currentValue)}
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay align="start">
        <ActionList selectionVariant="single" showDividers={false}>
          {enabledPanels.map(value => (
            <ActionList.Item key={value} selected={value === currentValue} onSelect={() => handleSelect(value)}>
              {getPanelHeading(value)}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
